import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from '@fiverr-private/fit';

import { LINKS, COPIES } from '../../../../constants';

const SeeAllPositionsLink = ({ className, isInHeader }) => (
    <Link to={`/${LINKS.TEAMS}`}>
        {isInHeader ? (
            <Button className={className} size={Button.SIZES.SMALL}>
                {COPIES.see_all_positions}
            </Button>
        ) : (
            COPIES.see_all_positions
        )}
    </Link>
);

SeeAllPositionsLink.propTypes = {
    isInHeader: PropTypes.bool,
    className: PropTypes.string,
};

export default SeeAllPositionsLink;
